/*
  Glossary page (sections/nr-glossary.liquid): the "Find a term" filter.
  Shows only the terms whose name or definition contains what's typed, and
  hides letters left empty. The filter stays hidden until this script runs.
*/
(function () {
  if (window.nrGlossaryFind) return;
  window.nrGlossaryFind = true;

  document.querySelectorAll('[data-glossary]').forEach(function (root) {
    var find = root.querySelector('[data-glossary-find]');
    var input = root.querySelector('[data-glossary-input]');
    var none = root.querySelector('[data-glossary-none]');
    var terms = Array.prototype.slice.call(root.querySelectorAll('[data-glossary-term]'));
    var groups = root.querySelectorAll('[data-glossary-group]');
    if (!find || !input) return;
    find.hidden = false;

    terms.forEach(function (term) {
      term.dataset.text = term.textContent.toLowerCase();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      terms.forEach(function (term) {
        var match = !q || term.dataset.text.indexOf(q) !== -1;
        term.hidden = !match;
        if (match) shown++;
      });
      groups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-glossary-term]:not([hidden])');
      });
      none.hidden = shown > 0;
    });
  });
})();
